import './About.css'
import logo from '../img/logo.png'
import { ArrowRight } from "lucide-react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';


function About(){
const [about,setAbout]=useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/public/about`,
          { withCredentials: true }
        );
        setAbout(response.data);
      } catch (error) {
        console.error("Error fetching home data:", error.message);
      }
    };

    fetchData();
  }, []);
    const items = [
        { answer: "We create highly engaging augmented and virtual reality solutions." },
        { answer: "Our team builds future-ready experiences beyond today’s trends." },
        { answer: "We collaborate with top brands to deliver impactful projects." }
      ];
    
      const [stages, setStages] = useState(Array(items.length).fill("idle"));
    
      const handleClick = (index) => {
        if (stages[index] !== "idle") return; 
    
      
        updateStage(index, "moved");
    
       
        setTimeout(() => {
          updateStage(index, "revealed");
    

          setTimeout(() => {
            updateStage(index, "idle");
          }, 5000);
        }, 2000);
      };
      const updateStage = (index, newStage) => {
        setStages((prev) => {
          const copy = [...prev];
          copy[index] = newStage;
          return copy;
        });
      };
    
    
return(
    <div className='about-container'>
    <div className='about-appoinment'>
<div className='about-appoinment-title'>We don't just build products — we craft realities that immerse, inspire, and innovate.</div>
<p>Let's create something immersive — schedule your appointment today.</p>
<Link to="/book"><button className="about-button">Book an Appoinment </button></Link>

    </div>
    <div className='aboutus-contain'>
 <div className='aboutus-title'>About</div>
    <div className='about-section'>
      <div className='about-image-container'>
    {about?.image && <img src={about.image} alt="About" />}
    </div>
    <div className='about-text'>
        
    <p>{about?.description}</p>
    </div>
    </div>
    </div>
    <div className='about-outter'>
    <div className="about-card" > 
    <div className="about-card-title">Why Creora Developers?</div>
    <p>"Because we don’t just follow trends — we build the next reality."</p>
    <div className="about-list">
        {items.map((item, index) => {
          const stage = stages[index];
          return (
            <div key={index} className="about-item">
             
              {stage !== "revealed" && (
                <button
                  className={`about-btn ${stage === "moved" ? "move-right" : ""}`}
                  onClick={() => handleClick(index)}
                >
                  <ArrowRight size={20} />
                </button>
              )}

          
              <div
                className={`about-line 
                  ${stage === "moved" ? "expanded" : ""} 
                  ${stage === "revealed" ? "revealed" : ""}`}
              >
                <div
                  className={`about-answer ${
                    stage === "revealed" ? "show" : ""
                  }`}
                >
                  {item.answer}
                </div>
              </div>
            </div>
          );
        })}
      </div>
</div>
</div>
    </div>
)
}
export default About;